import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.2/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/3.0.5/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.4.0/js/sparta-style-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import DataAssetLoader from "utilities/suits/data-asset-loader/2.1.1/js/data-asset-loader";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import spartaInputErrorUtility from "utilities/global/sparta-input-error-utility/7.2.1/js/sparta-input-error-utility";
import spartaInputFormattingUtility from "utilities/global/sparta-input-formatting-utility/2.1.1/js/sparta-input-formatting-utility";
import spartaInputAdaUtility from "utilities/global/sparta-input-ada-utility/1.0.1/js/sparta-input-ada-utility";
import spartaMaskingUtility from "utilities/global/sparta-masking-utility/5.1.2/js/sparta-masking-utility";







class SpartaInputUtility {






  constructor(selector, settings = {}) {

    this.isMobile = spartaStoreUtility.getData('browser').mobile;


    this.options = Object.assign({}, settings);

    this.inputs = [];
    this.optionInputs = [];

    this.counterOffset = 11;









    if (!selector.nodeName) {

      if (!selector[0]) {
        this.scope = document.querySelector(selector);
      } else {
        this.scope = selector[0];
      }
    } else {
      this.scope = selector;
    }


    spartaValidationFramework.init();


    this.init();
  }





  init(autoMask = true) {

    this.getInputs();
    this.getInputCheckboxes();


    this.getOptions();


    this.getTriggers();


    this.maskOptions = Object.assign({}, this.options.inputMaskOptionsExtend);


    this.getTextAreas();

    if (!this.importTriggered) {
      this.loadInputStrings().then((xhr) => {
        this.inputText = xhr.inputs;
        this.importTriggered = true;

        this.setHelpBttnText();
      });
    } else {
      this.setHelpBttnText();
    }


    const optionalText = spartaGlobalFunctions.getGlobalParams('optionalText');
    if (optionalText) {
      const optionalTextEls = document.querySelectorAll('.spa-input-label__optional-text');
      for (let i = 0; i < optionalTextEls.length; i++) {
        optionalTextEls[i].innerHTML = optionalText;
      }
    }


    this.boot(autoMask);
  }





  getInputs() {

    this.inputs = [].slice.call(this.scope.getElementsByClassName('spa-input-box'));
  }





  getInputCheckboxes() {

    this.inputCheckboxes = [].slice.call(this.scope.getElementsByClassName('spa-input-option'));
  }





  getOptions() {

    this.optionInputs = [].slice.call(this.scope.getElementsByClassName('spa-input-options-wrapper'));
  }





  getTriggers() {
    this.triggers = [].slice.call(this.scope.getElementsByClassName('toggle-trigger')).concat(
      [].slice.call(this.scope.getElementsByClassName('close-trigger'))
    );
  }






  getTextAreas() {
    this.inputs.filter((input) => {
      return input.classList.contains('spa-input-box--textarea')
               && input.querySelector('.spa-char-count');
    }).forEach((input) => {
      this.setCharCounter(input);
    });
  }





  setHelpBttnText() {
    const inputText = this.inputText;

    this.triggers.forEach((trigger) => {
      const label = trigger.getAttribute('aria-label');

      if (!label.includes(inputText.openHelp) && !label.includes(inputText.closeHelp)) {
        if (trigger.classList.contains('toggle-trigger')) {
          trigger.setAttribute('aria-label', inputText.openHelp.concat(label));
        } else if (trigger.classList.contains('close-trigger')) {
          (inputText.closeHelpADALabel) ? trigger.setAttribute('aria-label', inputText.closeHelpADALabel.concat(inputText.closeHelp.concat(label)))
            : trigger.setAttribute('aria-label', inputText.closeHelp.concat(label));
        }
      }
    });
  }





  loadInputStrings() {
    this.language = spartaGlobalFunctions.getLanguage();


    const messagingAssetLoader = new DataAssetLoader('global/sparta-input-utility', `data/${this.language}`);


    const load = messagingAssetLoader.loadAsset('inputs.json');




    const assetLoaderPromise = new Promise((resolve) => {




      spartaEventsUtility.sub(load.success, (evtData) => {

        resolve(evtData.data.xhr);
      }, true);
    });

    spartaEventsUtility.sub(load.failure, (evtData) => {

      if (window.console && console.warn) {
        console.warn(`Sparta Inputs: ${evtData.data.filename} AJAX Error.`, evtData.data.xhr);
      }
    }, true);

    return assetLoaderPromise;
  }





  boot(autoMask) {

    this.conditionalFields();


    this.changeInputTypes();


    spartaInputAdaUtility.init(this.inputs);
    spartaInputAdaUtility.init(this.inputCheckboxes);



    if (spartaInputFormattingUtility) {
      spartaInputFormattingUtility.init();
    }



    spartaMaskingUtility.init(autoMask);
  };





  conditionalFields() {

    this.optionInputs.forEach((container) => {

      if (container.hasAttribute('data-option-has-conditional-content')) {

        const conditionalContentFragment = document.createDocumentFragment();


        const conditionalContentContainerString = container.getAttribute('data-conditional-content');


        const conditionalContentOriginalContainer = document.getElementById(conditionalContentContainerString);


        if (!conditionalContentOriginalContainer) {
          return;
        }

        conditionalContentOriginalContainer.classList.add('spa-input-conditional-content-wrapper');
        conditionalContentOriginalContainer.classList.remove('spa-input-conditional-content-container');


        conditionalContentFragment.appendChild(conditionalContentOriginalContainer);


        let conditionalContentNewContainer = container.querySelector('data-option-conditional-content');


        if (!conditionalContentNewContainer) {

          conditionalContentNewContainer = document.createElement('div');


          conditionalContentNewContainer.setAttribute('data-option-conditional-content', true);
          conditionalContentNewContainer.classList.add('spa-input-option-conditional-content');


          container.appendChild(conditionalContentNewContainer);
        }


        conditionalContentNewContainer.appendChild(conditionalContentFragment);
      }
    });
  }







  changeInputTypes() {

    this.inputs.forEach((container) => {

      const input = container.querySelector('[data-mobile-input-type], [data-mobile-pattern]');


      if (input) {


        let type;
        let pattern;


        if (this.isMobile) {
          type = input.getAttribute('data-mobile-input-type');
          pattern = input.getAttribute('data-mobile-pattern');
        } else {
          type = input.getAttribute('data-default-input-type');
          pattern = input.getAttribute('data-default-pattern');
        }


        if (type && input.getAttribute('type') !== type) {
          input.setAttribute('type', type);
        }


        if (input.getAttribute('pattern') !== pattern) {
          input.setAttribute('pattern', pattern);
        }
      }
    });
  }






  setCharCounter(elementObj) {
    if (typeof elementObj !== 'undefined' && elementObj) {
      const charStore = this.charStore = {};
      const el = charStore.el = elementObj.querySelector('.spa-input-textarea');
      const countNode = charStore.countNode = elementObj.querySelector('.spa-char-count');
      const areaPosition = el.getBoundingClientRect();

      charStore.maxLength = countNode.dataset.charLimit || 100;
      if (el.parentNode.classList.contains('has-limit')) {

      } else {

      }
      countNode.classList.add('spa-char-count--loaded');

      el.addEventListener('keypress', this.updateCharCounter.bind(this));
      el.addEventListener('keyup', this.updateCharCounter.bind(this));
    }
  }






  updateCharCounter(event) {

    const charStore = this.charStore;
    const maxLength = charStore.maxLength;
    const el = charStore.el;
    const countNode = charStore.countNode;

    if (el.scrollHeight > el.clientHeight) {
      countNode.classList.add('spa-char-count--scrollbar');
    } else if (el.scrollHeight <= el.clientHeight && countNode.classList.contains('scrollbar')) {
      countNode.classList.remove('scrollbar');
    }


    if (event.keyCode === 13) { return false; }

    countNode.innerHTML = `${maxLength - parseInt(el.value.length, 10)} characters remaining`;
    if (el.value.length === maxLength) {
      event.preventDefault();
      return false;
    } else if (el.value.length > maxLength) {
      event.preventDefault();
      el.value = el.value.substring(0, maxLength);
    }
    return undefined;
  }
};

$.fn.bindHelp = function bindHelp() {
  const $elements = $(this);
  const namespace = 'inputHelp';

  return $elements.each(function iterateThroughElements() {
    const $trigger = $(this);
    const sInputId = $trigger.attr("id").replace('help-open-', '');
    const $targetHelpSection = $(`#helpLayer_${sInputId}`);
    const $targetHelpClose = $(`#help-close-${sInputId}`);


    $trigger.off(`click.${namespace}`);

    $trigger.on(`click.${namespace}`, () => {
      $targetHelpSection.slideToggle(150, () => {
        if ($targetHelpSection.is(':visible')) {
          $targetHelpSection.attr('aria-hidden', 'false');
          $targetHelpClose.attr('aria-hidden', 'false');
          $targetHelpClose.focus();
        } else {
          $targetHelpSection.attr('aria-hidden', 'true');
          $targetHelpClose.attr('aria-hidden', 'true');
        }
      });
    });

    $targetHelpClose.off(`click.${namespace}`);

    $targetHelpClose.on(`click.${namespace}`, () => {
      $targetHelpSection.slideUp(150, () => {
        $targetHelpClose.attr('aria-hidden', 'true');
        $targetHelpSection.attr('aria-hidden', 'true');
        $trigger.focus();
      });
    });
  });
};

$.fn.disableCopyAndPaste = function disableCopyAndPaste() {
  const namespace = 'disableCopyAndPaste';

  $(this).on(`cut.${namespace} copy.${namespace} paste.${namespace}`, (e) => {
    e.preventDefault();
  });
};


export default $.fn.spartaInputs = function spartaInputs(settings = {}) {

  let inputs;


  $(this).find('.toggle-trigger, .toggle-trigger-link').bindHelp();


  $(this).find('[data-sparta-input-format=ssn]').disableCopyAndPaste();


  return this.each(() => {
    inputs = new SpartaInputUtility($(this), settings);
  });
};
